export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ChangePhoneDialog.json?hash=84bad2933b94e6d6ab55def40e0d6602";